(function () {
  if (customElements.get('tp-product-tabs-v1')) return;

  const REALIGN_INTERVAL = 250;
  const REALIGN_TIMEOUT = 3000;
  const USER_SCROLL_EVENTS = ['wheel', 'touchstart', 'keydown', 'pointerdown'];

  class TpProductTabsV1 extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
      if (!(window.Shopify && window.Shopify.designMode)) this.hideMissingTargets();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.stopRealign) this.stopRealign();
    }

    // Esconde o botão cujo destino não está na página: as seções -meta não
    // renderizam (nem a âncora delas) quando o produto não tem o metaobjeto.
    hideMissingTargets() {
      const links = Array.from(this.querySelectorAll('.tp-e-product-tabs__link'));
      links.forEach((link) => {
        link.hidden = !this.targetOf(link);
      });

      const nav = this.querySelector('.tp-e-product-tabs__nav');
      if (nav) nav.hidden = links.every((link) => link.hidden);
    }

    targetOf(link) {
      const id = decodeURIComponent(link.hash.slice(1));
      return id ? document.getElementById(id) : null;
    }

    onClick = (event) => {
      const link = event.target.closest('.tp-e-product-tabs__link');
      if (!link || !this.contains(link)) return;

      const target = this.targetOf(link);
      if (!target) return;

      event.preventDefault();
      history.pushState(null, '', link.hash);
      this.scrollToTarget(target);
    };

    // Imagens lazy acima do destino carregam durante a rolagem e empurram a
    // seção para baixo; quando a rolagem para fora do lugar, realinha. Um novo
    // clique, qualquer interação do usuário ou o prazo encerram o realinhamento.
    scrollToTarget(target) {
      if (this.stopRealign) this.stopRealign();

      target.scrollIntoView({ block: 'start' });

      const deadline = Date.now() + REALIGN_TIMEOUT;
      let lastY = -1;
      let attempts = 0;

      const stop = () => {
        clearInterval(timer);
        USER_SCROLL_EVENTS.forEach((name) => window.removeEventListener(name, stop));
        this.stopRealign = null;
      };

      const timer = setInterval(() => {
        if (Date.now() > deadline) {
          stop();
          return;
        }

        const settled = Math.abs(window.scrollY - lastY) < 1;
        lastY = window.scrollY;
        if (!settled) return;

        const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
        const offset = target.getBoundingClientRect().top - margin;
        if (Math.abs(offset) <= 2 || attempts >= 4) {
          stop();
          return;
        }

        attempts += 1;
        target.scrollIntoView({ block: 'start' });
      }, REALIGN_INTERVAL);

      USER_SCROLL_EVENTS.forEach((name) => window.addEventListener(name, stop, { passive: true }));
      this.stopRealign = stop;
    }
  }

  customElements.define('tp-product-tabs-v1', TpProductTabsV1);
})();
